import { faker } from '@faker-js/faker'

import { HospitalView } from '../../contracts/hospital'

export const mockHospital = (): HospitalView => ({
  hospitalId: faker.number.int(),
  country: faker.location.countryCode(),
  name: faker.company.name(),
  introduction: faker.lorem.paragraph(),
  assessment: faker.helpers.arrayElement(['CERTIFIED', 'GROWTH', 'EFFORT']),
  activePhoneConsultation: faker.datatype.boolean(),
  activeChatConsultation: faker.datatype.boolean(),
  activeGeneralConsultation: faker.datatype.boolean(),
  badges: [
    {
      badgeCode: faker.string.uuid(),
      badgeName: faker.string.uuid(),
      badgeUrl: faker.image.url(),
    },
  ],
  treatmentTags: [
    {
      tagId: faker.number.int(),
      name: faker.string.uuid(),
    },
  ],
  images: {
    profileImageUrl: faker.image.url(),
    mainImageUrl: faker.image.url(),
    otherImages: [
      {
        sequence: faker.number.int(),
        imageUrl: faker.image.url(),
      },
    ],
  },
  statistic: {
    rating: faker.number.int(),
    reviewCount: faker.number.int(),
    eventCount: faker.number.int(),
    recentConsultationMemberCount: faker.number.int(),
  },
  location: {
    lat: faker.location.latitude(),
    lng: faker.location.longitude(),
    sido: faker.location.state(),
    sigungu: faker.location.city(),
    zipCode: faker.location.zipCode(),
    address: faker.location.streetAddress(),
    subwayNames: [faker.location.street()],
    wayToCome: null,
  },
  officeHours: {
    officeHours: {
      MON: '10:30-21:00',
      TUE: '10:30-21:00',
      WED: '10:30-21:00',
      THU: '10:30-21:00',
      FRI: '10:30-21:00',
      SAT: '10:30-21:00',
      SUN: '10:30-21:00',
    },
    officeHoursComment: faker.string.uuid(),
  },
  contact: {
    mainPhoneNumber: faker.phone.number(),
  },
  payment: {
    enableOfflinePointPayment: faker.datatype.boolean(),
    creditCards: {
      names: ['teat1', 'test2'],
      comment: faker.string.uuid(),
    },
    medicalLoan: {
      enabled: faker.datatype.boolean(),
      comment: faker.string.uuid(),
    },
  },
  updatedAt: faker.date.recent().toISOString(),
  createdAt: faker.date.recent().toISOString(),
})
